/**
 * <s-pattern-search> — Filters color chart pattern cards by name as the visitor types.
 *
 * Attributes:
 *   data-target                — Selector for the element holding the pattern families.
 * Child markup:
 *   input[data-pattern-search-input] — The search field.
 *   [data-pattern-search-empty]      — Shown when nothing matches.
 * Target markup:
 *   section[id^="family-"]     — A pattern family; hidden when none of its cards match.
 *   article[data-pattern]      — One card; matched against its h3 text.
 */
class SPatternSearch extends HTMLElement {
  #abort = null;

  connectedCallback() {
    const input = this.querySelector('[data-pattern-search-input]');
    if (!input) return;
    this.#abort = new AbortController();
    input.addEventListener('input', () => this.#filter(input.value), { signal: this.#abort.signal });
    if (input.value) this.#filter(input.value);
  }

  disconnectedCallback() {
    this.#abort?.abort();
  }

  #filter(value) {
    const target = document.querySelector(this.dataset.target);
    if (!target) return;
    const query = value.trim().toLowerCase();
    target.toggleAttribute('data-searching', Boolean(query));
    let matches = 0;
    target.querySelectorAll('section[id^="family-"]').forEach((section) => {
      let sectionMatches = 0;
      section.querySelectorAll('article[data-pattern]').forEach((card) => {
        const name = card.querySelector('h3')?.textContent.trim().toLowerCase() ?? '';
        const visible = !query || name.includes(query);
        card.hidden = !visible;
        if (visible) sectionMatches += 1;
      });
      section.hidden = sectionMatches === 0;
      matches += sectionMatches;
    });
    const empty = this.querySelector('[data-pattern-search-empty]');
    if (empty) empty.hidden = matches > 0;
  }
}

if (!customElements.get('s-pattern-search')) {
  customElements.define('s-pattern-search', SPatternSearch);
}
